import React from "react";
const ErrorMessageComponent = ({ touched, error, className = 'formik-error' }) => {

  if(!error) return;

  return (
    <h6
      style={{
        fontSize: ".9em",
        color: "#FC3C3C",
        fontWeight: 400,
        marginTop: "4px",
        transition: ".2s all",
      }}
      className={className}
    >
      {touched && error ? error : ""}
    </h6>
  );
};

export default ErrorMessageComponent;
